export default {
    title: 'Settings',
    subtitle: 'Manage API keys and service configurations',
    loading: 'Loading settings...',
    tabs: {
        apiKeys: 'API Keys',
        serviceConfigs: 'External Services',
        preferences: 'Preferences',
    },
    apiKeys: {
        title: 'API Keys',
        description: 'Manage API keys for external services',
        newKey: 'New API Key',
        searchPlaceholder: 'Search by name, service...',
        categoryPlaceholder: 'Filter by category',
        allCategories: 'All categories',
        headers: {
            name: 'Name',
            service: 'Service',
            category: 'Category',
            type: 'Type',
            status: 'Status',
            actions: 'Actions',
        },
        status: {
            active: 'Active',
            inactive: 'Inactive',
        },
        modal: {
            edit: 'Edit API Key',
            new: 'New API Key',
            fields: {
                name: 'Name',
                namePlaceholder: 'Key name',
                service: 'Service',
                servicePlaceholder: 'Service name',
                category: 'Category',
                type: 'Type',
                value: 'Value',
                valuePlaceholder: 'Enter key value',
                description: 'Description',
                descriptionPlaceholder: 'Optional description',
            },
        },
        actions: {
            edit: 'Edit',
            delete: 'Delete',
        },
    },
    serviceConfigs: {
        title: 'External Services',
        description: 'Configurations for external services',
        newService: 'New Service',
        searchPlaceholder: 'Search by name...',
        categoryPlaceholder: 'Filter by category',
        headers: {
            name: 'Name',
            category: 'Category',
            baseUrl: 'Base URL',
            status: 'Status',
            actions: 'Actions',
        },
        modal: {
            edit: 'Edit Service',
            new: 'New Service',
            fields: {
                name: 'Name',
                namePlaceholder: 'Service name',
                category: 'Category',
                baseUrl: 'Base URL',
                baseUrlPlaceholder: 'https://api.example.com',
                config: 'JSON Configuration',
                configPlaceholder: '{"key": "value"}',
            },
        },
        actions: {
            edit: 'Edit',
            delete: 'Delete',
        },
    },
    modal: {
        cancel: 'Cancel',
        save: 'Save Changes',
        create: 'Create',
        confirmDelete: 'Are you sure you want to delete this item?',
    },
};

